// To override the API server on the command line when building or serving
// using settings in .env.local or by just setting the env var
// When deploying, we set these urls in the CI env before building
const defaultApiBaseUrl = "https://web.staging.ptflow.me/api/1";
export const baseUrl = process.env.REACT_APP_API_BASE || defaultApiBaseUrl;

export const api = {
  auth: `${baseUrl}/auth`,
  user: `${baseUrl}/users`,
  clients: `${baseUrl}/customers`,
  countries: `${baseUrl}/countries`,
  events: `${baseUrl}/events`,
  stats: `${baseUrl}/stats`,
  exportStats: `${baseUrl}/stats/sessions/export`,
  exercises: `${baseUrl}/catalog`,
  workoutsCatalog: `${baseUrl}/catalog`,
  shareWorkouts: `${baseUrl}/workouts`,
  schedule: `${baseUrl}/events/schedule`,
  images: `${baseUrl}/images`,
  plans: `${baseUrl}/plans`,
  dashboard: `${baseUrl}/events/dashboard`,
  contact: `${baseUrl}/contact`,
};

export const settingsRoutes = [
  "/settings",
  "/settings/profile",
  "/settings/availability",
  "/settings/statistics",
  "/settings/general",
];
export const TopLevelRoutes = ["/", "/clients", "/schedules", "/workouts", "/exercises"];
